module.exports = __webpack_public_path__ + "media/stylesheets/images/media/userway_function_icons/icn-feature-37-2efde6244dedb56600275f6cee4c3204.svg";